// /aller/devis/:ref et /aller/piece/:id — un lien cité par l'assistant.
// Le modèle cite une RÉFÉRENCE, pas une URL : on retrouve l'identifiant
// côté serveur, puis on ouvre le devis.
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ErrorState, Skeleton } from '../../ui/States.jsx';
import api from '../../lib/api.js';

export function AllerVers({ type }) {
  const { cible } = useParams();
  const navigate = useNavigate();
  const [erreur, setErreur] = useState(null);
  useEffect(() => {
    api.get(`/assistant/lien/${type}/${encodeURIComponent(cible)}`)
      .then((r) => navigate(`/devis/${r.devis_id}`, { replace: true }))
      .catch(setErreur);
  }, [type, cible, navigate]);
  return erreur ? <ErrorState error={erreur} title="Lien introuvable" /> : <Skeleton height="40vh" />;
}

export default AllerVers;
